module.exports = __webpack_public_path__ + "static/media/COS_L_OREAL.8dd7f455.jpg";